/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextArticleTIcon20Regular = forwardRef('TextArticleTIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.75 3a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H5.75v4.5a.75.75 0 0 1-1.5 0v-4.5H2.5A.75.75 0 0 1 1.75 3Z" }),
        React.createElement("path", { d: "M11 3.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z" }),
        React.createElement("path", { d: "M10.25 8a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M3 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" }),
        React.createElement("path", { d: "M3 15.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H3Z" })));
});
